// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/map.twh.nlbe.scss';

// i18n
import i18n from '../../i18n/nl-BE';

import map from './map';

map(i18n);
